<div [class.isPrinting]="printService.isPrinting">


  <!--<div class="row">


    <div class="form-group col-md-12 col-xs-12">

      <div class="image-upload-box" *ngIf="CurrentActorPersonalDetailInfoController.ActorCode >0">

        <img class="img-circle-65px" [src]='CurrentActorPersonalDetailInfoController.ActorImageFileUrl' height="50" width="50" alt="">
        <imageinfo [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'
                   [CanEdit]="1" [CanShow]="1"
                   (actorImageInfoChange)="onactorImageInfoChange($event)"
                   *ngIf="CurrentActorPersonalDetailInfoRequest.ActorCode >0"></imageinfo>
      </div>
      <imageinfo [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'
      [CanEdit]="1" [CanShow]="1"
      (actorImageInfoChange)="onactorImageInfoChange($event)"
      *ngIf="CurrentActorPersonalDetailInfoRequest.ActorCode >0"
      ></imageinfo>


      <div class="user-status">
        <h3 class="bold-text user-title">{{CurrentActorPersonalDetailInfoRequest.DisplayName}}</h3>
        <span class="i-text">{{CurrentActorPersonalDetailInfoRequest.ProfileTitle}}</span>
        <span>Designation <span>|</span> Hours <span>|</span> Shift <span>|</span> $0</span>
      </div>
    </div>
  </div>-->
  <!--<div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px">
          Profile Header
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
        </div>
        <div class="card-body card-body-general">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="profileTitle"><span>*</span> Title </label>
              </div>
              <div class="col-md-8">

                <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       name="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       placeholder="Title" maxlength="50" minlength="1" #ProfileTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$" required>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileTitle.valid && (ProfileTitle.dirty || ProfileTitle.touched) && ProfileTitle.errors.required )">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileTitle.valid && ProfileTitle.errors.pattern)">(special characters are not allowed)</small>

              </div>
            </div>

          </div>
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="profileSummary">Summary</label>
              </div>
              <div class="col-md-8">
                <textarea class="form-control" rows="2" placeholder="Summary" id="CurrentActorPersonalDetailInfoRequest.ProfileSummary"
                          [(ngModel)]="CurrentActorPersonalDetailInfoRequest.ProfileSummary"
                          name="CurrentActorPersonalDetailInfoRequest.ProfileSummary" maxlength="1000" #ProfileSummary="ngModel"
                          pattern="^[\sa-zA-Z0-9,._\-?]*$"></textarea>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileSummary.valid && ProfileSummary.errors.pattern)">(special characters are not allowed)</small>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>-->

  <div class="row margin-left-0px personal-profile-wrapper" *ngIf="SelectedPatient">

    <!-- Top Profile Actions Bar Card -->
    <div class="col-md-12 col-12 padding-l-0px">
      <div class="card profile-action-card">
        <div class="card-header action-header">
          <div class="header-title-group">
            <div class="header-icon-box">
              <i class="fas fa-id-card"></i>
            </div>
            <div>
              <h3 class="header-title">Profile Details</h3>
              <p class="header-subtitle" *ngIf="SelectedPatient.FormattedCode">Code: {{SelectedPatient.FormattedCode}}</p>
            </div>
          </div>
          <div class="action-btn-group">
            <button type="submit" class="btn btn-profile-action btn-partner" (click)="Partner()" *ngIf="SelectedPatient.PatientCategory=='IVF'">
              <i class="fas fa-user-friends"></i> Partner
            </button>
            <button type="submit" class="btn btn-profile-action btn-edit" (click)="EditDetails()" *canUserAccess="['HL_REG_6']">
              <i class="fas fa-pencil-alt"></i> Edit
            </button>
            <button type="submit" class="btn btn-profile-action btn-add-partner" (click)="AddPartner()" *canUserAccess="['HL_REG_AddPartner']">
              <i class="fas fa-user-plus"></i> + Partner
            </button>
            <button type="submit" class="btn btn-profile-action btn-couple" (click)="printcaserecord()" *canUserAccess="['HL_REG_7']">
              <i class="fa fa-print"></i> Couple
            </button>
            <button type="submit" class="btn btn-profile-action btn-individual" (click)="printcaserecordind()" *canUserAccess="['HL_REG_8']">
              <i class="fa fa-print"></i> Individual
            </button>
            <button type="submit" class="btn btn-profile-action btn-photo" (click)="ChangeImage()" *canUserAccess="['HL_REG_9']">
              <img class="img-circle img-size2 margin-right-3px" height="18px" width="18px" [src]='SelectedPatient.PatientImageFile' onError="this.src='dummy.jpg';"> Photo
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- General Information Card -->
    <div class="col-md-12 col-12">
      <div class="card profile-info-card">
        <div class="card-header section-header clickable-header" (click)="toggleGeneral()">
          <div class="section-title-wrap">
            <div class="section-icon-badge icon-general">
              <i class="fas fa-user"></i>
            </div>
            <span class="section-title-text">General Details</span>
          </div>
          <i class="fas fa-chevron-down section-toggle-arrow" [class.rotated]="isGeneralCollapsed"></i>
        </div>
        <div class="card-body section-body" *ngIf="!isGeneralCollapsed">
          <div class="detail-grid">
            <div class="detail-card">
              <span class="detail-label">Name</span>
              <span class="detail-value highlight-value">{{SelectedPatient.DisplayName || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Date of Birth</span>
              <span class="detail-value">{{(SelectedPatient.DateOfBirth | date:'dd-MMM-yyyy') || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Age</span>
              <span class="detail-value">{{SelectedPatient.Age || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Sex</span>
              <span class="detail-value">{{SelectedPatient.Gender || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Religion</span>
              <span class="detail-value">{{SelectedPatient.Religion || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Occupation</span>
              <span class="detail-value">{{SelectedPatient.Occupation || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Organisation</span>
              <span class="detail-value">{{SelectedPatient.Organisation || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Blood Group</span>
              <span class="detail-value blood-value" *ngIf="SelectedPatient.BloodGroup">{{SelectedPatient.BloodGroup}}</span>
              <span class="detail-value" *ngIf="!SelectedPatient.BloodGroup">---</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Marital Status</span>
              <span class="detail-value">{{SelectedPatient.MaritalStatus || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">ID Proof</span>
              <span class="detail-value">{{SelectedPatient.IdProof || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Nationality</span>
              <span class="detail-value">{{SelectedPatient.Nationality || '---'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Education Card -->
    <div class="col-md-12 col-12">
      <div class="card profile-info-card">
        <div class="card-header section-header clickable-header" (click)="toggleEducation()">
          <div class="section-title-wrap">
            <div class="section-icon-badge icon-education">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <span class="section-title-text">Education</span>
          </div>
          <i class="fas fa-chevron-down section-toggle-arrow" [class.rotated]="isEducationCollapsed"></i>
        </div>
        <div class="card-body section-body" *ngIf="!isEducationCollapsed">
          <div class="detail-grid">
            <div class="detail-card">
              <span class="detail-label">Education Level</span>
              <span class="detail-value">{{SelectedPatient.EducationTitle || '---'}}</span>
            </div>
            <div class="detail-card span-2">
              <span class="detail-label">Education in Detail</span>
              <span class="detail-value">{{SelectedPatient.EducationInDetail || '---'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Referral Details Card -->
    <div class="col-md-12 col-12">
      <div class="card profile-info-card">
        <div class="card-header section-header clickable-header" (click)="toggleReferral()">
          <div class="section-title-wrap">
            <div class="section-icon-badge icon-referral">
              <i class="fas fa-user-friends"></i>
            </div>
            <span class="section-title-text">Referral Details</span>
          </div>
          <i class="fas fa-chevron-down section-toggle-arrow" [class.rotated]="isReferralCollapsed"></i>
        </div>
        <div class="card-body section-body" *ngIf="!isReferralCollapsed">
          <div class="detail-grid">
            <div class="detail-card">
              <span class="detail-label">Referral Type</span>
              <span class="detail-value">{{SelectedPatient.RefType || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Referral Name</span>
              <span class="detail-value">{{SelectedPatient.RefDetails || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Referral Contact</span>
              <span class="detail-value">{{SelectedPatient.RefContactNo1 || '---'}}</span>
            </div>
            <div class="detail-card">
              <span class="detail-label">Referral Institute</span>
              <span class="detail-value">{{SelectedPatient.RefInstitute || '---'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Address Card -->
    <div class="col-md-12 col-12">
      <div class="card profile-info-card">
        <div class="card-header section-header clickable-header" (click)="toggleAddress()">
          <div class="section-title-wrap">
            <div class="section-icon-badge icon-address">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <span class="section-title-text">Address</span>
          </div>
          <i class="fas fa-chevron-down section-toggle-arrow" [class.rotated]="isAddressCollapsed"></i>
        </div>
        <div class="card-body section-body" *ngIf="!isAddressCollapsed">
          <div class="detail-grid">
            <div class="detail-card">
              <span class="detail-label">Line 1</span>
              <span class="detail-value">{{SelectedPatient.AddressLine1 || '---'}}</span>
            </div>
            <div class="detail-card span-2">
              <span class="detail-label">Line 2 & City</span>
              <span class="detail-value">
                <ng-container *ngIf="SelectedPatient.AddressLine2">{{SelectedPatient.AddressLine2}}</ng-container>
                <ng-container *ngIf="SelectedPatient.AddressLine2 && SelectedPatient.City">, </ng-container>
                <ng-container *ngIf="SelectedPatient.City">{{SelectedPatient.City}}</ng-container>
                <ng-container *ngIf="!SelectedPatient.AddressLine2 && !SelectedPatient.City">---</ng-container>
              </span>
            </div>
            <div class="detail-card">
              <span class="detail-label">State & Zip Code</span>
              <span class="detail-value">
                <ng-container *ngIf="SelectedPatient.State">{{SelectedPatient.State}}</ng-container>
                <ng-container *ngIf="SelectedPatient.State && SelectedPatient.ZipCode"> & </ng-container>
                <ng-container *ngIf="SelectedPatient.ZipCode">{{SelectedPatient.ZipCode}}</ng-container>
                <ng-container *ngIf="!SelectedPatient.State && !SelectedPatient.ZipCode">---</ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Card -->
    <div class="col-md-12 col-12">
      <div class="card profile-info-card">
        <div class="card-header section-header clickable-header" (click)="toggleContact()">
          <div class="section-title-wrap">
            <div class="section-icon-badge icon-contact">
              <i class="fas fa-address-book"></i>
            </div>
            <span class="section-title-text">Contact</span>
          </div>
          <i class="fas fa-chevron-down section-toggle-arrow" [class.rotated]="isContactCollapsed"></i>
        </div>
        <div class="card-body section-body" *ngIf="!isContactCollapsed">

          <div class="detail-grid">
            <div class="detail-card contact-item">
              <span class="detail-label"><i class="fas fa-mobile-alt me-1 text-primary"></i> Mobile</span>
              <span class="detail-value font-weight-bold primary-text">{{SelectedPatient.Telephone1 || '---'}}</span>
            </div>
            <div class="detail-card contact-item">
              <span class="detail-label"><i class="fas fa-envelope me-1 text-primary"></i> Email</span>
              <span class="detail-value font-weight-bold primary-text">{{SelectedPatient.Email || '---'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-4 col-12 padding-l-0px" hidden>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          General
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="firstName">Full Name </label>
                </div>:
                <div class="col-md-6 text-align-left">

                  <!--<input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.FirstName"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.FirstName"
                       name="CurrentActorPersonalDetailInfoRequest.FirstName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                       placeholder="First Name" maxlength="20" minlength="1" #FirstName="ngModel" required>
                <small class="form-text text-danger"
                       *ngIf="(!FirstName.valid && (FirstName.dirty || FirstName.touched) && FirstName.errors.required )">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!FirstName.valid && FirstName.errors.pattern)">(special characters are not allowed)</small>-->
                  <label>{{SelectedPatient.DisplayName}}</label>
                </div>
                <!--<div class="col-md-3">

                <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.MiddleName"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MiddleName"
                       name="CurrentActorPersonalDetailInfoRequest.MiddleName"
                       placeholder="Middle Name" maxlength="20" pattern="^[\sa-zA-Z0-9,._\-?]*$" #MiddleName="ngModel" required>
                <small class="form-text text-danger"
                       *ngIf="(!MiddleName.valid && MiddleName.errors.pattern)">(special characters are not allowed)</small>

              </div>
              <div class="col-md-3">


                <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.LastName"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.LastName"
                       name="CurrentActorPersonalDetailInfoRequest.LastName"
                       placeholder="Last Name" required maxlength="20" minlength="1" #LastName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                <small class="form-text text-danger"
                       *ngIf="(!LastName.valid && (LastName.dirty || LastName.touched) && LastName.errors.required)">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!LastName.valid && LastName.errors.pattern)">(special characters are not allowed)</small>

              </div>-->
              </div>

            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="birthDate"> Date of Birth  </label>
                </div>:
                <div class="col-md-6 text-align-left">
                  <label>{{SelectedPatient.DateOfBirth | date:'dd-MMM-yyyy'}}</label>
                  <!--<div class="date-form">
                  <input class="form-control" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                         name="dp" [(ngModel)]="DOB" ngbDatepicker #d="ngbDatepicker" required #DateOfBirth="ngModel">
                  <small class="form-text text-danger"
                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>-->

                </div>


              </div>
            </div>

          </div>
          <div class="row" hidden>
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Age  </label>
                </div>:
                <div class="col-md-6 text-align-left">
                  <!--<input type="number" class="form-control" minlength="2" placeholder="Age">-->
                  <!--id="CurrentActorPersonalDetailInfoRequest.DisplayName"
                [(ngModel)]="CurrentActorPersonalDetailInfoRequest.DisplayName"
                name="CurrentActorPersonalDetailInfoRequest.DisplayName"
                placeholder="Display Name" required maxlength="40" minlength="1" #DisplayName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"-->
                  <!--<small class="form-text text-danger"
                       *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required)">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>-->
                  <label>{{SelectedPatient.Age}}</label>
                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Sex</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.Gender}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Occupation</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.Occupation}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Organisation</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.Organisation}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Religion</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.Religion}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Blood Group</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.BloodGroup}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName">Marital Status</label>
                </div>:
                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="MARTL" id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
                [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
                name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"></CodeTypeValue>-->
                  <label>{{SelectedPatient.MaritalStatus}}</label>
                  el
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Nationality</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.Nationality}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> ID Proof</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.IdProof}}</label>

                </div>
              </div>


            </div>
          </div>

          <!--<div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-5 padding-right-0px text-align-left">
                <label for="diaplayName"> Mother Tongue</label>
              </div>:

              <div class="col-md-6 text-align-left">
                <label>{{SelectedPatient.MotherTongue}}</label>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-5 padding-right-0px text-align-left">
                <label for="diaplayName">Languages Known</label>
              </div>:

              <div class="col-md-6 text-align-left">
                <label>{{SelectedPatient.LanguagesKnown}}</label>

              </div>
            </div>


          </div>
        </div>-->
        </div>
      </div>
    </div>
    <div class="col-md-4 col-12 padding-l-0px" hidden>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          Education Details
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Education Level</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.EducationTitle}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Education in Detail</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.EducationInDetail}}</label>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px" hidden>
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          Registration Details
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Registration Type</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RegistrationType}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Registration Reason</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RegistrationReason}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Registration Current</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RegistrationReason}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Billing Category</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.BillingCategory}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Registration Validity</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RegistrationValidity}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Primary Care Giver</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.PrimaryDoctor}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Insurance Provider</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.InsuranceProvider}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Wedding Date</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label></label>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>



    </div>
    <div class="col-md-4 col-12 padding-l-0px" hidden>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          Referral Details
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Referral Type</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RefType}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Referral Name</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RefDetails}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Referral Contact</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RefContactNo1}}</label>

                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 padding-right-0px text-align-left">
                  <label for="diaplayName"> Referral Institute</label>
                </div>:

                <div class="col-md-6 text-align-left">
                  <!--<CodeTypeValue CodeType="Sex">

                </CodeTypeValue>-->
                  <label>{{SelectedPatient.RefInstitute}}</label>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          Address
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row text-align-left">
                <div class="col-md-8 padding-right-0px">
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px padding-left-17px">
                      <label class="margin-bottom-0px">{{SelectedPatient.AddressLine1}},</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px">
                      <label class="margin-bottom-0px">{{SelectedPatient.AddressLine2}}, {{SelectedPatient.City}},</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px">
                      <label class="margin-bottom-0px"> {{SelectedPatient.ZipCode}}, {{SelectedPatient.State}}</label>
                    </div>
                  </div>


                </div>
              </div>


            </div>
          </div>


          <!--<div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="diaplayName">Zip </label>
              </div>
              <div class="col-md-3">
                <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Zip"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Zip"
                       name="CurrentActorPersonalDetailInfoRequest.Zip" #Zip="ngModel" pattern="[0-9]{5}"
                       placeholder="Zip" maxlength="5" />
                <small class="form-text text-danger"
                       *ngIf="(!Zip.valid && Zip.errors.pattern)">(special characters are not allowed)</small>
              </div>
            </div>


          </div>
        </div>-->


        </div>
      </div>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          <div class="row">
            <div class="col-md-5">
              Contact
            </div>
            <!--<div class="col-md-3">
            <a (click)="EditDetails()" class="nav-link-hand education-navlink float-right date-color-contracts" title="Edit">
              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
            </a>
          </div>
          <div class="col-md-2">
            <a class="nav-link-hand education-navlink data-color-new" title="Couple" (click)="printcaserecord()">
              <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
            </a>
          </div>
          <div class="col-md-2">
            <a class="nav-link-hand education-navlink data-color-new" title="Individual" (click)="printcaserecordind()">
              <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
            </a>
          </div>-->
          </div>
        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-1  text-align-center">
                  <label for="diaplayName"> <i class="fas fa-mobile-alt font-size-color"></i> </label>
                </div>:
                <div class="col-md-5 padding-left-2px text-align-left">
                  <!--<input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone1"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone1"
                       mask="(000) 000-0000"
                       name="CurrentActorPersonalDetailInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel"
                       placeholder="Mobile Phone" />
                <small class="form-text text-danger"
                       *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                  <label>{{SelectedPatient.Telephone1}}</label>
                </div>
              </div>


            </div>
          </div>
          <!--<div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="diaplayName">Telephone </label>
              </div>
              <div class="col-md-3">
                <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone2"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone2"
                       mask="(000) 000-0000"
                       name="CurrentActorPersonalDetailInfoRequest.Telephone2" pattern="[0-9]{10}" #Telephone2="ngModel"
                       placeholder="Telephone" />
                <small class="form-text text-danger"
                       *ngIf="(!Telephone2.valid)">(Provide Valid Phone No)</small>
              </div>
            </div>


          </div>
        </div>-->
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-1 text-align-left padding-left-13px padding-right-18px">
                  <label for="email address"><i class="fas fa-envelope font-size-color"></i></label>
                </div>:
                <div class="col-md-10 padding-left-2px text-align-left">
                  <!--<input type="email" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Email"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Email"
                       name="CurrentActorPersonalDetailInfoRequest.Email"
                       placeholder="Email" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                       #Email="ngModel" maxlength="30" minlength="4">
                <small class="form-text text-danger"
                       *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>-->
                  <label>{{SelectedPatient.Email}}</label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>



  </div>




    <!--<div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
          Emergency
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
        </div>
        <div class="card-body card-body-general">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-3 text-align-right">
                  <label for="email address">Contact Person </label>
                </div>
                <div class="col-md-4">
                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName" #EmergencyContactPersonName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         placeholder="Contact Person" maxlength="40" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyContactPersonName.valid && EmergencyContactPersonName.errors.pattern)">(special characters are not allowed)</small>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-3 text-align-right">
                  <label for="firstName">Contact Number</label>
                </div>
                <div class="col-md-3">

                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1"
                         mask="(000) 000-0000"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1" pattern="[0-9]{10}" #EmergencyContactNo1="ngModel"
                         placeholder="Contact Number" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyContactNo1.valid)">(Provide Valid Contact Number)</small>

                </div>


              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="firstName"> Address</label>
                </div>

                <div class="col-md-3">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         placeholder="Address" maxlength="100" #EmergencyAddress="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyAddress.valid && EmergencyAddress.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>
            </div>
          </div>
        </div>




        </div>

            </div>
      </div>-->








    <div class="row" *ngIf="CanEdit === 1 " hidden>
      <div class="card-footer text-right col-12">
        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

      </div>
    </div>
    <!--<div class="row margin-bottom-10px">
    <div class="col-md-12 padding-lr-0px">
      <div class="card margin-left-zero margin-right">
        <div class="card-body padding-all-0px margin-left-zero">
          <myidentities></myidentities>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-bottom-10px">
    <div class="col-md-12 padding-lr-0px">
      <div class="card margin-lr-19px">
        <div class="card-body padding-all-0px margin-left-zero">
          <resumeupload [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'></resumeupload>
        </div>
      </div>
    </div>
  </div>-->

    <router-outlet></router-outlet>
    <router-outlet name="print"></router-outlet>
    <router-outlet></router-outlet>
    <router-outlet name="printIDL"></router-outlet>
  </div>





